<template>
  <asc-dialog
    :show-dialog="showDialog"
    text="Export APU Cycles"
    :on-close="onCloseDialog"
    :on-primary="handleAccept"
    :primary-available="isCurrentDataValid"
    primary-button-text="Submit"
    full-width-buttons
    :width="500"
  >
    <template v-if="showDialog">
      <asc-apu-cycle-export
        v-model="currentData"
        :airlines="airlines"
        :master-models="masterModels"
      ></asc-apu-cycle-export>
    </template>
  </asc-dialog>
</template>

<script>
import { AscDialogMixin } from '@/components/mixins'
import AscDialog from '@/components/atoms/AscDialog'
import AscApuCycleExport from './AscApuCycleExport'

export default {
  name: 'AscApuCycleExportDialog',

  components: {
    AscDialog,
    AscApuCycleExport,
  },

  mixins: [AscDialogMixin],

  props: {
    airlines: {
      type: Array,
      default: () => [],
    },
    masterModels: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      currentData: null,
    }
  },

  computed: {
    isCurrentDataValid() {
      if (!this.currentData) {
        return false
      }
      if (!this.currentData.date) {
        return false
      }
      if (this.currentData.airlineIds.length === 0) {
        return false
      }
      if (this.currentData.masterModelNames.length === 0) {
        return false
      }
      return true
    },
  },

  methods: {
    handleAccept() {
      this.onAccept(this.currentData)
      this.handleClose()
      this.currentData = null
    },
    onCloseDialog() {
      this.handleClose()
      this.currentData = null
    },
  },
}
</script>
